import { render, staticRenderFns } from "./LocationLogo.vue?vue&type=template&id=1af8761e&lang=pug"
import script from "./LocationLogo.vue?vue&type=script&lang=coffee"
export * from "./LocationLogo.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports